import { Component, HostListener, Input } from '@angular/core';
import { Header, Section } from '../../../dto/response/template.config';
import { Select } from '@ngxs/store';
import { TemplateConfigState } from '../../../store/states/templateConfig.state';
import { Observable } from 'rxjs';
import { NgClass } from '@angular/common';
import { TopBarComponent } from '../top-bar/top-bar.component';
import { TemplateConfigService } from '../../../service/template-config.service';
import { SecondBarComponent } from '../second-bar/second-bar.component';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [NgClass, TopBarComponent, SecondBarComponent],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent {
  @Select(TemplateConfigState.templateConfigHeader)
  headerConfig$: Observable<Header>;
  headerConfig: Header;
  topBarSection: Section | undefined;
  secondBarSection: Section | undefined;
  data: any | null;
  logo: string | null | undefined;
  @Input() class: string;
  @Input() sticky: boolean | number | undefined; // Default false
  public stick: boolean = false;

  constructor(private templateConfigService: TemplateConfigService) {}

  ngOnInit() {
    this.headerConfig$.subscribe((header) => {
      this.headerConfig = header;
      this.topBarSection = this.findSection(this.headerConfig, 'top-bar');
      this.secondBarSection = this.findSection(this.headerConfig, 'second-bar');
      console.log('headerConfig:' + header);
    });
  }

  // @HostListener Decorator
  @HostListener('window:scroll', [])
  onWindowScroll() {
    const number =
      window.scrollY ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;
    if (number >= 50 && window.innerWidth > 400) {
      this.stick = true;
    } else {
      this.stick = false;
    }
  }

  private findSection(
    headerConfig: Header,
    sectionId: string,
  ): Section | undefined {
    return this.templateConfigService.findSectionById(
      headerConfig.sections,
      sectionId,
    );
  }
}
